import { moduleProviderFactory } from "core/providers";
import { 
	MissingInventoryFlagReportList
 } from "application/missing-inventory-flag-report/pages";

(function() {
	moduleProviderFactory.application.register({
		routes: [
			{
				name: "master.app.main.missing-inventory-flag-report",
				pattern: "/missing-inventory-flag-report",
				children: [
					{
						name: "master.app.main.missing-inventory-flag-report.list",
						pattern: "",
						tabTitle: "MENU.MISSING_INVETNORY_FLAG_REPORTS",
						component: MissingInventoryFlagReportList,
						authorization: "reportSection.read",
						data: {
							title: "MENU.MISSING_INVETNORY_FLAG_REPORTS",
						},
					}
				],
			},
		],
		menu : [
            {
                title: 'MENU.REPORTS',
                order: 9,
				icon: "table-view",
				authorization: "reportSection.read",
                subMenu: [
                    {
                        title: "MENU.MISSING_INVETNORY_FLAG_REPORTS",
						authorization: "coreUserSection.read",
						route: "master.app.main.missing-inventory-flag-report.list",
						order: 4
                    }                    
                ]
            }
        ]
	});
})();
